import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from 'vue-router';
import { useUserStore } from '@/stores/user';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('../views/login/login.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: () => import('../views/login/resetPassword.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('../views/home/index.vue'),
      children: [
        {
          path: '',
          name: 'liveBroadcast',
          component: () => import('../views/home/liveBroadcast.vue'),
          meta: { requiresAuth: false },
        },
        {
          path: 'roleManage',
          name: 'roleManage',
          component: () => import('../views/home/roleManage.vue'),
          meta: {
            requiresAuth: false,
          },
        },
        {
          path: 'editRole',
          name: 'editRole',
          component: () => import('../views/home/editRole.vue'),
          meta: { requiresAuth: true },
        },
        {
          path: 'voiceManage',
          name: 'voiceManage',
          component: () => import('../views/home/voiceManage.vue'),
          meta: { requiresAuth: false },
        },
        {
          path: 'editVoice',
          name: 'editVoice',
          component: () => import('../views/home/editVoice.vue'),
          meta: { requiresAuth: true },
        },
        {
          path: 'deviceManage',
          name: 'deviceManage',
          component: () => import('../views/home/deviceManage.vue'),
          meta: { requiresAuth: false },
        },
        {
          path: 'product',
          name: 'product',
          component: () => import('../views/home/StoreProduct.vue'),
          meta: { requiresAuth: false },
        },
        {
          path: 'editProduct',
          name: 'editProduct',
          component: () => import('../views/home/StoreProductEdit.vue'),
          meta: { requiresAuth: true },
        },
        {
          path: 'productConfig',
          name: 'productConfig',
          component: () => import('../views/home/StoreProductConfig.vue'),
          meta: { requiresAuth: false },
        },
      ],
    },
    {
      path: '/liveRoomSetting',
      name: 'liveRoomSetting',
      component: () => import('../views/liveRoom/liveRoomSetting.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/knowledge',
      name: 'knowledge',
      component: () => import('../views/knowledge/index.vue'),
      meta: { requiresAuth: false, keepAlive: true },
    },
  ],
});

// 全局路由守卫
// const userStore = useUserStore();
// router.beforeEach(async (to) => {
//   let token = localStorage.getItem('token');
//   if (token) {
//     return '/home/';
//   }
//   if (to.meta.requiresAuth && !userStore.token) {
//     return '/';
//   }

//   if (to.path === '/home' && userStore.token) {
//     return '/';
//   }
// });

// 路由前置守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    const isAuthenticated = checkAuth();
    if (!isAuthenticated) {
      // 未登录则重定向到登录页面
      next();
    } else {
      // 已登录则继续
      next('/home/');
    }
  } else if (to.matched.some((record) => record.meta.requiresAuth)) {
    // 检查用户是否已登录
    const isAuthenticated = checkAuth();

    if (!isAuthenticated) {
      // 未登录则重定向到登录页面
      // next({
      //   path: '/',
      //   query: { redirect: to.fullPath }, // 记录要重定向的路径
      // });

      // 检查是否有重定向路径(子组件写法)
      // const redirect = router.currentRoute.value.query.redirect
      // router.push(redirect || '/home/')
      next();
    } else {
      // 已登录则继续
      next();
    }
  } else {
    // 不需要认证的路由直接放行
    next();
  }
});

// 检查用户是否登录的函数
function checkAuth() {
  // 从localStorage中获取登录状态
  return localStorage.getItem('token') || '';
}

export default router;
